import { faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import {
  ContactsContainerStyled,
  ContactsStyled,
  FontAwesomeIconStyled,
  InfoContainer,
  TypographyStyled,
} from './ContactsFinantech.styles';

export const ContactsFinantech = () => (
  <ContactsContainerStyled>
    <ContactsStyled>
      <FormattedMessage id="TRLT_UI-CONTACTS" />
    </ContactsStyled>
    <InfoContainer>
      <FontAwesomeIconStyled icon={faPhone} />
      <TypographyStyled id="finantechPhoneNumber">
        <FormattedMessage id="TRLT_UI-PHONE_NUMBER" />
      </TypographyStyled>
    </InfoContainer>
    <InfoContainer>
      <FontAwesomeIconStyled icon={faLocationDot} />
      <TypographyStyled>
        <FormattedMessage id="TRLT_UI-ADRESSE" />
      </TypographyStyled>
    </InfoContainer>
  </ContactsContainerStyled>
);
